module.exports = __webpack_public_path__ + "mollie-logo.aef7bbb411084c19e4b6788212150d1e.svg";